// extracted by mini-css-extract-plugin
export default {"root":"logo-module--root---HQSm","svg":"logo-module--svg--d29YC"};